<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      PickList Type Question
    </div>
    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="backUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>
    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>
    <div class="card-body overflow-x-hidden nav-item dropdown p-2" style="max-height: 80vh; overflow-y: auto;">
      <div class="card mb-2">
        <div class="card-header btn-primary" (click)="showTitlePanel = !showTitlePanel" style="cursor:pointer;">
          <b>Question Title</b>
          <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showTitlePanel, 'fa-chevron-right': !showTitlePanel}"></i></span>
        </div>
        <div class="collapse" [ngClass]="{'show': showTitlePanel}">
          <div class="card-body">
            <div class="col-md-12 card-body p-1">
              <form [formGroup]="pickListForm" #f="ngForm">
                <div class="form-group">
                  <table align="center" width="98%">
                    <tr>
                      <td colspan="3">
                        <div class="row mb-3">
                          <label data-required for="description" class="form-control-label col-md-2"> Title <sup class="text-danger">&ast;</sup></label>
                          <div class="col-md-10">
                            <!--<input type="text" id="description" name="description" formControlName="description" class="form-control" style="margin-left:-21px;" />-->
                            <textarea rows="10" class="form-control" id="description" name="description" formControlName="description" style="margin-left:-21px;"></textarea>
                            <small class="text-danger" *ngIf="pickListForm.get('description')?.touched && !pickListForm.get('description')?.valid">
                              Please enter the required (*) fields.
                            </small>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width="60%">
                        <div class="row mb-3">
                          <label class="form-control-label col-md-3" for="questionCategoryId"> Category</label>
                          <div class="col-md-7">
                            <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control">
                              <option value="" selected>--Select--</option>
                              <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                                {{item.questionCategoryName}}
                              </option>
                            </select>
                          </div>
                        </div>
                      </td>
                      <td width="40%" colspan="2">
                        <div class="row">
                          <div class="col-md-3">
                            <button type="button" class="btn btn-primary btn-action" style="margin-left: -80px;"
                                    (click)="openCategoryModal()">
                              <i class="fa fa-plus"></i> Create Category
                            </button>
                          </div>
                          <label class="col-md-3 form-control-label" for="width">Width</label>
                          <div class="col-md-4"><input class="form-control" maxlength="1000" type="number" id="width" name="width" formControlName="width" placeholder="Width" /></div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width="60%">
                        <div class="row mb-3">
                          <label class="form-control-label col-md-3" for="shortName">Short Name</label>
                          <div class="col-md-7"><input class="form-control" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" /></div>
                        </div>
                      </td>
                      <td width="20%"></td>
                      <td width="20%"></td>
                    </tr>
                  </table>
                </div>

                <div class="row col-md-12">
                  <div class="col-md-6"></div>
                  <div class="col-md-6 text-end">
                    <button type="submit" class="btn btn-secondary btn-action pull-right" (click)="backUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null"><i class="fa fa-times"></i> Cancel</button>
                    <button type="button" class="btn btn-secondary btn-action pull-right" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-times"></i> Cancel</button>
                    <button type="button" class="btn btn-primary btn-action pull-right" (click)="saveQuestion()"><i class="fa fa-plus"></i> Create / Update</button>

                  </div>
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
      <div class="card mb-2">
        <div class="card-header btn-primary" (click)="showConfigPanel = !showConfigPanel" style="cursor:pointer;">
          <b>Options Configuration</b>
          <span class="float-end"><i class="fa" [ngClass]="{'fa-chevron-down': showConfigPanel, 'fa-chevron-right': !showConfigPanel}"></i></span>
        </div>
        <div class="collapse" [ngClass]="{'show': showConfigPanel}">
          <div class="card-body">
            <form [formGroup]="pickListForm" #f="ngForm">
              <div class="row px-2 mb-3">
                <label class="col-md-4 form-control-label ps-0" for="questionOption">&nbsp;Option Name</label>
                <div class="col-md-4"><input class=" form-control" maxlength="1000" type="text" id="questionOption" name="questionOption" formControlName="questionOption" placeholder="Option" /></div>
                <div class="col-md-4 d-flex gap-3">
                  <button type="button" class="btn btn-secondary btn-action" (click)="resetForm()"><i class="fa fa-eraser"></i> Clear</button>
                  <button (click)="addChoice()" type="button" class="btn btn-primary btn-action" [disabled]="this.questionId===0"><i class="fa fa-plus"></i> Create / Update</button>
                  <button type="button" class="btn btn-primary btn-action" (click)="arrangeOrder()"><i class="fa fa-reorder"></i>Update Order</button>
                </div>
              </div>
              <div class="row mb-3">
                <label class="col-md-4 form-control-label" for="weightage">Weight</label>
                <div class="col-md-4"><input class="form-control" maxlength="10" type="text" id="weightage" name="weightage" formControlName="weightage" placeholder="weight" /></div>
              </div>
              <div class="row mb-3">
                <label class="col-md-4 form-control-label" for="optionShortName">Short Name</label>
                <div class="col-md-4"><input class="form-control" maxlength="30" type="text" id="optionShortName" name="optionShortName" formControlName="optionShortName" placeholder="Short Name" /></div>
              </div>
            </form>
            <br />
            <div class="overflow-auto" style="max-height:200px">
              <isg-grid [rowData]="questionOptionList"
                        [columnDefs]="columnDefs"
                        [config]="optionGridConfig"
                        (gridReady)="onQuestionGridReady($event)">
              </isg-grid>
              <!--<ag-grid-angular style="height: 250px;"
                               class="ag-theme-balham"
                               [enableSorting]="true"
                               [rowData]="questionOptionList"
                               [rowDragManaged]="true"
                               [columnDefs]="columnDefs"
                               (gridReady)="onQuestionGridReady($event)">
              </ag-grid-angular>-->
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
  <ng-template #deleteOptionConfirmation let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Delete Option Confirmation</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="form-control-label">
        Are you sure you want to delete the selected option?
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="deleteOptions(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
      <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    </div>
  </ng-template>
</div>

<ng-template #CreateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"> Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="col-md-4 form-control-label" for="quesCategoryName">Category<sup class="text-danger">&ast;</sup></label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>
